import React from 'react'
import { StyledReturnLink } from './TheWestHeaderLogin.styled'
import { TheWestReturn } from '../TheWestReturn/TheWestReturn'

export const RegionalActionLink: React.FC = () => {
    return (
        <StyledReturnLink to="https://thewest.com.au" isPrimary={true}>
            <TheWestReturn />
        </StyledReturnLink>
    )
}

RegionalActionLink.displayName = 'RegionalActionLink'
